export enum PrizeType {
	Cash = "Cash",
	Upgrade = "Upgrade"
}
